export const initialState = () => ({
  name: "",
  active: false
})
